import { Badge } from '@/components/ui/Badge';
import { cn } from '@/lib/cn';
import type { CsTicketPriority, CsTicketStatus, CsTier } from '@/api/cs/tickets.api';
import { PRIORITY_META, STATUS_META, TIER_META } from './meta';

/**
 * Shared CS badge components (Phase 16 / ADR-026) — status, priority,
 * and triage-tier chips reused by the queue, ticket detail, and the
 * Operations pages. Label/variant maps live in ./meta.ts.
 */

export function StatusBadge({ status }: { status: CsTicketStatus }) {
  const meta = STATUS_META[status];
  return <Badge variant={meta.variant}>{meta.label}</Badge>;
}

export function PriorityBadge({ priority }: { priority: CsTicketPriority }) {
  const meta = PRIORITY_META[priority];
  return <Badge variant={meta.variant}>{meta.label}</Badge>;
}

export function TierBadge({ tier }: { tier: CsTier }) {
  const meta = TIER_META[tier];
  return <Badge variant={meta.variant}>{meta.label}</Badge>;
}

export function TagChip({ tag, className }: { tag: string; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-kw-full bg-kw-bg px-2 py-0.5 text-[11px] font-medium text-kw-muted',
        className,
      )}
    >
      {tag}
    </span>
  );
}
